// SuccessMessageBanner.tsx
import React, { useEffect } from 'react';
import './CompanyManagement.css';

interface SuccessMessageBannerProps {
  message: string;
  isVisible: boolean;
  onClose: () => void;
  autoCloseDelay?: number; // Auto close after X milliseconds
}

export const SuccessMessageBanner: React.FC<SuccessMessageBannerProps> = ({
  message,
  isVisible,
  onClose,
  autoCloseDelay = 5000 // Default 5 seconds
}) => {
  useEffect(() => {
    if (isVisible && autoCloseDelay > 0) {
      const timer = setTimeout(() => {
        onClose();
      }, autoCloseDelay);

      return () => clearTimeout(timer);
    }
  }, [isVisible, autoCloseDelay, onClose]);

  if (!isVisible) return null;

  return (
    <div className="success-message-banner">
      <div className="success-message-icon">
        ✓
      </div>
      <div className="success-message-text">
        {message}
      </div>
      <button
        onClick={onClose}
        className="success-message-close"
        aria-label="Close success message"
      >
        ✕
      </button>
    </div>
  );
};

// Alternative inline version (if you prefer it within the page content)
export const SuccessMessageInline: React.FC<SuccessMessageBannerProps> = ({
  message,
  isVisible,
  onClose
}) => {
  if (!isVisible) return null;

  return (
    <div className="success-message-inline">
      <div className="success-message-icon">
        ✓
      </div>
      <div className="success-message-text">
        {message}
      </div>
      <button
        onClick={onClose}
        className="success-message-close"
        aria-label="Close success message"
      >
        ✕
      </button>
    </div>
  );
};